module.exports = __webpack_public_path__ + "static/media/logo.2da2cbad.png";